export class InvalidRouteIntParamError extends Error {
  constructor(paramName: string, value: string) {
    super(`The parameter "${paramName}" is expected to be an integer, but got "${value}".`);
    this.name = 'InvalidRouteParamError';
  }
}
